import { Navigate, Route, Routes } from 'react-router-dom';

import { EconomyRoute } from './economy.route';
import { PortfolioEconomySettingsRoute } from './portfolio-economy-settings.route';
import { EconomyTabPlaceholder } from './components';

export * from './economy.paths';

export function EconomyRouter() {
  return (
    <Routes>
      <Route path="/" element={<EconomyRoute />}>
        {/* Innstillinger is the only tab with content, so it is what `/economy` opens on. */}
        <Route index element={<Navigate to="settings" replace />} />
        <Route path="summary" element={<EconomyTabPlaceholder tabKey="summary" />} />
        <Route path="budget-status" element={<EconomyTabPlaceholder tabKey="budgetStatus" />} />
        <Route path="operations" element={<EconomyTabPlaceholder tabKey="operations" />} />
        <Route path="settlement" element={<EconomyTabPlaceholder tabKey="settlement" />} />
        <Route path="company-costs" element={<EconomyTabPlaceholder tabKey="companyCosts" />} />
        <Route path="settings" element={<PortfolioEconomySettingsRoute />} />
      </Route>
    </Routes>
  );
}

export default EconomyRouter;
